import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { contractConstants, contractModels } from '..';

export const useOnlineContractClientSignatureRefreshId = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: { contractId: number }) => {
      const res = await $api.get(`/v1/online-contract/client-signature/refresh/${data?.contractId}`);

      return res?.data;
    },
    {
      onSuccess: async (data: { data: contractModels.IOnlineContractClientSignatureId }, { contractId }) => {
        if (data?.data) {
          await qc.setQueryData(
            [contractConstants.queryKeys.ONLINE_CONTRACT_CLIENT_SIGNATURE, contractId],
            () => data?.data
          );
        }
      }
    }
  );
};
